module.exports = {"minimum":100000,"image":{"alpha":1},"video":{"alpha":4},"file":{"alpha":4},"document":{"alpha":1}}


//////////////////
// WEBPACK FOOTER
// ./src/configs/ticket-document-maxsize.config.json
// module id = 4VER
// module chunks = 0